seedWebApp.controller('DicIntegrationsController', ['$scope', 'DicService', 'ToastService',
    function ($scope, DicService, ToastService) {

        $scope.prefs = {
            name: 'DicColsGrid',
            sortByCol: null,
            canAdd: false,
            canEdit: true,
            canDelete: false
        };

        $scope.countService = DicService.getIntegrationsCount;
        $scope.loadService = DicService.searchIntegrations;
        $scope.loadColumns = DicService.getIntegrationColumns;

        $scope.resetService = DicService.resetCache;

        $scope.qtStockClass = function (item) {
            return 'qt-stocks';
        };

        $scope.qtStatusClass = function (item) {
            return 'StatusBtn DicStatus' + item;
        };


        $scope.columns = [
            { name: 'Name', display: 'Nome', customClass: function () { return 'agp-color'; }, filterOptions: [], width: 10, isKey: true },
            { name: 'ModuleName', display: 'Módulo', filterOptions: [], limitTo: '25', width: 5, customClass: $scope.qtStockClass  },
            { name: 'Status', display: 'Status', filterOptions: [], limitTo: '35', width: 15, customClass: $scope.qtStatusClass },
            { name: 'Label', display: 'Label', filterOptions: [], limitTo: '35', width: 15 },            
            { name: 'Description', display: 'Descricao', filterOptions: [], limitTo: '35', width: 5 },
            { name: 'TargetName', display: 'Destino', filterOptions: [], limitTo: '35', width: 5 },
            //{ name: 'Mappings', display: 'Mapeamentos', filterOptions: [], limitTo: '35', width: 15 },
        ];

        //$scope.insertNew = function () {
        //    DicService.openDicModal();
        //}

        //$scope.prefs.customEdit = function (item) {
        //    DicService.openDicModal(item.DicID);
        //};

        $scope.getTotal = function () {
            $scope.loadingTotal = true;
            $scope.countService().then(function (response) {
                $scope.loadingTotal = false;
                $scope.totalItems = response.data;
            });
        };

        $scope.getTotal();

        $scope.searchMode = function () {
            $scope.$broadcast('inputSearch', $scope.filterString);
        };

        $scope.doRefresh = function () {
            $scope.$broadcast('refreshServiceGrid');
        };

        $scope.toExcel = function () {
            $scope.$broadcast('toExcel', 'dicIntegrations');
        };

      

    }]);
